module.exports = __webpack_public_path__ + "Flag-16.df7e38fab6f63fd4389d4bb337dd1374.svg";